import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { useLanguage } from "../../context/LanguageContext";

const experiences = [
  {
    company: "HAWNAN Tech",
    role: {
      en: "Mobile Developer · Part-time, Remote",
      id: "Mobile Developer · Paruh waktu, Remote",
    },
    period: { en: "May 2026 — Present", id: "Mei 2026 — Sekarang" },
    highlights: {
      en: [
        "Developing the Masjid Sejuta Pemuda Phase 3 mobile application as a Flutter developer.",
        "Engineering MSPay/Xendit payment flows for donations and infaq, Event and Kajian registration, wallet top-ups, and Coffee Bar/POS checkout.",
        "Building payment-channel selection, QRIS, Virtual Account and manual-transfer handling, expiry countdowns, status recovery, and unified transaction history.",
        "Delivering the Exam and Certification modules end-to-end, including automatic digital certificate generation and download.",
        "Extending the Jamaah Subscription system with family packages and the supporting user flows.",
        "Designing the light/dark theme foundation and redesigning the home page, navigation, and critical components with glassmorphism.",
      ],
      id: [
        "Mengembangkan aplikasi Masjid Sejuta Pemuda Fase 3 sebagai Flutter developer.",
        "Membangun flow pembayaran MSPay/Xendit untuk donasi dan infaq, registrasi Event dan Kajian, top-up wallet, serta checkout Coffee Bar/POS.",
        "Mengembangkan pemilihan channel pembayaran, QRIS, Virtual Account dan transfer manual, countdown kedaluwarsa, status recovery, serta riwayat transaksi terpadu.",
        "Mengembangkan Modul Ujian dan Sertifikasi secara end-to-end, termasuk pembuatan dan pengunduhan sertifikat digital otomatis.",
        "Mengembangkan sistem Jemaah Subscription dengan paket keluarga beserta alur pengguna pendukungnya.",
        "Merancang fondasi light/dark theme serta melakukan redesign halaman utama, navigasi, dan komponen penting dengan glassmorphism.",
      ],
    },
    stack: [
      "Flutter",
      "BLoC/Cubit",
      "MSPay/Xendit",
      "ObjectBox",
      "Freezed",
      "GetIt/Injectable",
      "Dio",
    ],
    portfolioTitle: {
      en: "Published Masjid Sejuta Pemuda application",
      id: "Aplikasi Masjid Sejuta Pemuda yang telah diterbitkan",
    },
    portfolio: [
      {
        name: "Masjid Sejuta Pemuda · Android",
        description: {
          en: "Islamic community application with integrated payments, donations, subscriptions, exams, and certification.",
          id: "Aplikasi komunitas Islam dengan pembayaran, donasi, subscription, ujian, dan sertifikasi terintegrasi.",
        },
        href: "https://play.google.com/store/apps/details?id=com.hawnan.msp",
      },
      {
        name: "Masjid Sejuta Pemuda · iOS",
        description: {
          en: "The iOS release of the Masjid Sejuta Pemuda mobile experience.",
          id: "Versi iOS dari pengalaman mobile Masjid Sejuta Pemuda.",
        },
        href: "https://apps.apple.com/id/app/masjid-sejuta-pemuda/id6777368076?l=id",
      },
    ],
  },
  {
    company: "PT Ring Media Nusantara",
    role: {
      en: "Full-stack Developer · Project-based",
      id: "Full-stack Developer · Berbasis proyek",
    },
    period: { en: "2025 — Present", id: "2025 — Sekarang" },
    highlights: {
      en: [
        "Building MyRingNet, a full-stack ISP operations platform for customers, companies and partners, service packages, billing, payments, finance, documents, support tickets, and operational reporting.",
        "Implementing ISP infrastructure modules for POP locations, Radius NAS and routers, authentication profiles, user sessions, histories, daily usage analytics, maps, dashboards, and notifications.",
        "Developing Ringnet Invoice Management with invoice lifecycle and payment tracking, proof-of-transfer uploads, dynamic bank/e-wallet/QRIS methods, finance records, customer support chat tracking, and multi-role staff access.",
        "Delivering REST APIs and responsive admin experiences with authentication, validation, file handling, PDF/QR generation, WhatsApp-ready billing, structured logging, and production health checks.",
        "Supporting production delivery using Docker, PM2, PostgreSQL migrations, GitHub Actions CI/CD, and VPS deployment workflows.",
      ],
      id: [
        "Mengembangkan MyRingNet, platform operasional ISP full-stack untuk pelanggan, perusahaan dan mitra, paket layanan, billing, pembayaran, keuangan, dokumen, support ticket, serta laporan operasional.",
        "Membangun modul infrastruktur ISP untuk lokasi POP, Radius NAS dan router, profil autentikasi, sesi pengguna, riwayat, analytics penggunaan harian, peta, dashboard, dan notifikasi.",
        "Mengembangkan Ringnet Invoice Management dengan lifecycle invoice dan pembayaran, unggah bukti transfer, metode bank/e-wallet/QRIS dinamis, pencatatan keuangan, support chat tracking, dan akses staf multi-role.",
        "Menyediakan REST API dan admin web responsif dengan autentikasi, validasi, file handling, PDF/QR, tagihan siap WhatsApp, structured logging, serta production health check.",
        "Mendukung delivery production menggunakan Docker, PM2, migrasi PostgreSQL, GitHub Actions CI/CD, dan deployment VPS.",
      ],
    },
    stack: [
      "Next.js/React",
      "Node.js/Express",
      "PostgreSQL",
      "Prisma",
      "JWT",
      "Docker",
    ],
    portfolioTitle: {
      en: "ISP management products",
      id: "Produk manajemen ISP",
    },
    portfolio: [
      {
        name: "MyRingNet · Frontend",
        description: {
          en: "Next.js admin dashboard for end-to-end ISP operations.",
          id: "Admin dashboard Next.js untuk operasional ISP end-to-end.",
        },
        href: "https://github.com/zainalsalamun/my-ringnet-frontend",
      },
      {
        name: "MyRingNet · Backend",
        description: {
          en: "Modular Express, Prisma, and PostgreSQL REST API.",
          id: "REST API modular berbasis Express, Prisma, dan PostgreSQL.",
        },
        href: "https://github.com/zainalsalamun/my-ringnet-backend",
      },
      {
        name: "Ringnet Invoice · Frontend",
        description: {
          en: "Responsive billing dashboard with PDF, QR, and WhatsApp workflows.",
          id: "Dashboard billing responsif dengan alur PDF, QR, dan WhatsApp.",
        },
        href: "https://github.com/zainalsalamun/invoice-web",
      },
      {
        name: "Ringnet Invoice · Backend",
        description: {
          en: "Secure billing, customer, finance, and support REST API.",
          id: "REST API aman untuk billing, pelanggan, keuangan, dan support.",
        },
        href: "https://github.com/zainalsalamun/ringnet-invoice-backend",
      },
    ],
  },
  {
    company: "Yokke",
    role: {
      en: "Assistant Manager · Mobile Developer",
      id: "Assistant Manager · Mobile Developer",
    },
    period: { en: "Dec 2024 — Present", id: "Des 2024 — Sekarang" },
    highlights: {
      en: [
        "Developing and maintaining a Flutter Inventory Management System for Android field operations using clean architecture and scalable state management.",
        "Integrating the application with the IMS backend for real-time and offline-first operational workflows.",
        "Implementing EDC monitoring, including serial number tracking, device status, and condition.",
        "Building preventive and corrective maintenance work orders with assignment, visit, pending, completion, and validation flows.",
        "Delivering GPS-stamped camera uploads, location resolution, stock opname, asset reconciliation, and offline synchronization.",
      ],
      id: [
        "Mengembangkan dan memelihara Inventory Management System Flutter untuk operasional lapangan Android dengan clean architecture dan state management yang skalabel.",
        "Mengintegrasikan aplikasi dengan backend IMS untuk proses operasional real-time dan offline-first.",
        "Membangun monitoring EDC yang mencakup serial number, status perangkat, dan kondisi perangkat.",
        "Mengembangkan work order preventive dan corrective maintenance dengan assignment, status kunjungan, pending, selesai, dan validasi.",
        "Mengimplementasikan unggah foto dengan GPS dan lokasi, stock opname, rekonsiliasi aset, serta sinkronisasi offline.",
      ],
    },
    stack: ["Flutter", "Clean Architecture", "Offline-first", "REST API"],
  },
  {
    company: "Binar Academy",
    role: { en: "Mobile Developer", id: "Mobile Developer" },
    period: { en: "Apr 2021 — Dec 2024", id: "Apr 2021 — Des 2024" },
    highlights: {
      en: [
        "Developed Flutter applications for Android and iOS while collaborating with UI/UX and backend teams.",
        "Built Yokke Biz Lite, a point-of-sale product with GetX, Dio, OTP, bank transfer, and QRIS payment integrations.",
        "Developed OCBC Nyala Bisnis Merchant with Firebase, OneSignal, static QRIS generation, build flavors, and MVVM architecture.",
        "Implemented new and change requests, API integrations, performance improvements, and ongoing bug resolution.",
        "Supported SIT/UAT, TestFlight, Firebase Distribution, and multi-environment release processes.",
      ],
      id: [
        "Mengembangkan aplikasi Flutter Android dan iOS bersama tim UI/UX dan backend.",
        "Membangun Yokke Biz Lite, produk point-of-sale dengan GetX, Dio, OTP, transfer bank, dan integrasi pembayaran QRIS.",
        "Mengembangkan OCBC Nyala Bisnis Merchant dengan Firebase, OneSignal, QRIS statis, build flavor, dan arsitektur MVVM.",
        "Mengerjakan new/change request, integrasi API, peningkatan performa, dan penyelesaian bug berkelanjutan.",
        "Mendukung proses SIT/UAT, TestFlight, Firebase Distribution, dan rilis multi-environment.",
      ],
    },
    stack: ["Flutter", "GetX", "Firebase", "QRIS", "MVVM"],
  },
  {
    company: "Jutive Group",
    role: {
      en: "Freelance Flutter Developer",
      id: "Freelance Flutter Developer",
    },
    period: { en: "Nov 2023 — Apr 2024", id: "Nov 2023 — Apr 2024" },
    highlights: {
      en: [
        "Converted comprehensive UI/UX designs into a production-ready Flutter HR application.",
        "Implemented geolocation attendance, face detection, and Face ID authentication for secure employee check-ins.",
        "Delivered payslip management, reimbursement, leave requests, and timesheet submission workflows.",
        "Integrated GetX, Dio, Get Storage, Geolocator, Camera, Shared Preferences, and Image Picker.",
      ],
      id: [
        "Menerjemahkan desain UI/UX yang komprehensif menjadi aplikasi HR Flutter siap produksi.",
        "Mengimplementasikan absensi berbasis lokasi, face detection, dan autentikasi Face ID untuk check-in karyawan.",
        "Membangun pengelolaan slip gaji, reimbursement, pengajuan cuti, dan pengiriman timesheet.",
        "Mengintegrasikan GetX, Dio, Get Storage, Geolocator, Camera, Shared Preferences, dan Image Picker.",
      ],
    },
    stack: ["Flutter", "GetX", "Dio", "Geolocation", "Camera"],
    portfolioTitle: {
      en: "Published HR application",
      id: "Aplikasi HR yang telah diterbitkan",
    },
    portfolio: [
      {
        name: "EZYHRM · Android",
        description: {
          en: "A mobile HRMS for workforce management, attendance, leave, reimbursement, payslips, and timesheets.",
          id: "HRMS mobile untuk tenaga kerja, absensi, cuti, reimbursement, slip gaji, dan timesheet.",
        },
        href: "https://play.google.com/store/apps/details?id=com.ezyhr.ezyhr_mobile_apps",
      },
    ],
  },
  {
    company: "Buana Varia Komputama",
    role: { en: "Android Developer", id: "Android Developer" },
    period: { en: "Nov 2016 — Apr 2021", id: "Nov 2016 — Apr 2021" },
    highlights: {
      en: [
        "Focused on designing, building, releasing, and maintaining native Android hospital reservation applications.",
        "Managed the complete delivery process across development, staging, and production environments.",
        "Built hospital reservation flows, doctor schedules, reservation history, room availability, and patient medical information.",
        "Integrated external APIs and data sources while continuously improving reliability, performance, and maintainability.",
        "Collaborated with cross-functional teams, performed testing, resolved production issues, and adopted new Android technologies.",
      ],
      id: [
        "Berfokus merancang, membangun, merilis, dan memelihara aplikasi reservasi rumah sakit berbasis Android native.",
        "Mengelola proses delivery lengkap untuk environment development, staging, dan production.",
        "Membangun reservasi rumah sakit, jadwal dokter, riwayat reservasi, ketersediaan kamar, dan informasi medis pasien.",
        "Mengintegrasikan API dan sumber data eksternal sekaligus meningkatkan stabilitas, performa, dan maintainability.",
        "Berkolaborasi dengan tim lintas fungsi, melakukan testing, menyelesaikan masalah production, dan mengadopsi teknologi Android terbaru.",
      ],
    },
    stack: ["Android", "Java", "REST API", "Healthcare"],
    portfolioTitle: {
      en: "Hospital reservation portfolio",
      id: "Portofolio aplikasi reservasi rumah sakit",
    },
    portfolio: [
      {
        name: "Palma RSUD Kota Bogor",
        description: {
          en: "Hospital reservations, doctor schedules, visit history, and patient medical information.",
          id: "Reservasi rumah sakit, jadwal dokter, riwayat kunjungan, dan informasi medis pasien.",
        },
        href: "https://play.google.com/store/apps/dev?id=5296606901092369555",
      },
      {
        name: "Reservasi RS Balaraja",
        description: {
          en: "Online reservations, doctor schedules, medical resumes, and electronic prescriptions.",
          id: "Reservasi online, jadwal dokter, resume medis, dan resep elektronik.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservbalaraja",
      },
      {
        name: "TARTIMAH RS CIMACAN",
        description: {
          en: "Online reservations, doctor schedules, medical summaries, and bed occupancy information.",
          id: "Reservasi online, jadwal dokter, resume medis, dan informasi ketersediaan tempat tidur.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservcimacan",
      },
      {
        name: "RAOS · Reservasi RS Sayang",
        description: {
          en: "Patient reservations, doctor schedules, medical resumes, and bed information.",
          id: "Reservasi pasien, jadwal dokter, resume medis, dan informasi tempat tidur.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservsayang",
      },
      {
        name: "Reservasi RSDP KabSerang",
        description: {
          en: "Online reservations, doctor schedules, medical summaries, and hospital information.",
          id: "Reservasi online, jadwal dokter, resume medis, dan informasi rumah sakit.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservserang",
      },
      {
        name: "Reservasi Permata Medika",
        description: {
          en: "General and BPJS reservations, room information, and doctor schedules.",
          id: "Reservasi umum dan BPJS, informasi ruang rawat, serta jadwal dokter.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservpermatamedika",
      },
      {
        name: "SiPintar RS Annisa",
        description: {
          en: "Mobile online registration, doctor schedules, and bed occupancy information.",
          id: "Pendaftaran online mobile, jadwal dokter, dan informasi ketersediaan tempat tidur.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservannisa",
      },
      {
        name: "Reservasi RSUD Tobelo",
        description: {
          en: "General and BPJS reservations, doctor schedules, and bed usage information.",
          id: "Reservasi umum dan BPJS, jadwal dokter, dan informasi pemakaian tempat tidur.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservtobelo",
      },
      {
        name: "Reservasi RS Dr Pirngadi",
        description: {
          en: "Mobile outpatient registration, doctor schedules, and bed usage information.",
          id: "Pendaftaran rawat jalan mobile, jadwal dokter, dan informasi pemakaian tempat tidur.",
        },
        href: "https://play.google.com/store/apps/details?id=bvk.reservpirngadi",
      },
    ],
  },
];

function ExperienceTimeline() {
  const { language, t } = useLanguage();

  return (
    <section className="experience-section" aria-labelledby="experience-title">
      <header className="experience-header">
        <span className="section-eyebrow">{t("experience.eyebrow")}</span>
        <h2 id="experience-title">{t("experience.title")}</h2>
        <p>{t("experience.subtitle")}</p>
      </header>

      <div className="experience-timeline">
        {experiences.map((experience, index) => (
          <div className="experience-item" key={`${experience.company}-${experience.period.en}`}>
            <div className="experience-rail" aria-hidden="true">
              <span>{String(index + 1).padStart(2, "0")}</span>
            </div>

            <article className="experience-card">
              <div className="experience-card-header">
                <div>
                  <h3>{experience.company}</h3>
                  <p>{experience.role[language]}</p>
                </div>
                <time>{experience.period[language]}</time>
              </div>

              <ul>
                {experience.highlights[language].map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>

              <div className="experience-stack">
                {experience.stack.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>

              {experience.portfolio && (
                <div className="experience-portfolio">
                  <div className="experience-portfolio-heading">
                    <strong>
                      {experience.portfolioTitle?.[language] ||
                        t("experience.publishedApps")}
                    </strong>
                  </div>

                  <div
                    className={`experience-app-grid${
                      experience.portfolio.length === 1
                        ? " experience-app-grid-single"
                        : experience.portfolio.length === 2
                        ? " experience-app-grid-double"
                        : ""
                    }`}
                  >
                    {experience.portfolio.map((app) => (
                      <a
                        href={app.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={app.name}
                      >
                        <span>
                          <strong>{app.name}</strong>
                          <small>{app.description[language]}</small>
                        </span>
                        <FiArrowUpRight aria-hidden="true" />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </article>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ExperienceTimeline;
